import ReactModal from "react-modal";
import React, { useState } from "react";
import styled from "styled-components";
import "./Ces.css";
import BgR from "./images/popupBg.png";
import { P } from "../CommonStyle";
import Tick from "./images/tick.svg";
import { checkPublicDomain, userTrack } from "../Common";
import { useEffect } from "react";
import Download from "./images/dwnld-w.svg";
import { useRouter } from "next/router";
import Image from "next/image";

const PopupWrap = styled.div`
  position: relative;
  min-height: 200px;
  background: #fff;
  margin: 0 auto;
  height: auto !important;
  overflow: hidden !important;
  border-radius: 11px;
  border: none;
  outline: none;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 767px) {
    width: auto !important;
    padding: 0 15px;
    display: initial;
  }
`;

const BannerLeft = styled.div`
  background-image: url(${BgR.src});
  background-size: cover;
  background-repeat: no-repeat;
  height: 590px;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;
const ContentRWrap = styled.div`
  padding: 0 60px;
  padding-top: 20px;
`;
const ListWrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 35px;
`;
const TickImg = styled.div`
  margin-top: 8px;
`;
const ListContent = styled.div`
  color: #fff;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.4px;
`;
const BannerRight = styled.div`
  padding: 5px 60px;
  overflow-y: auto;
  max-height: 583px;
  width: 405px;
  padding-bottom: 20px;
  padding-top: 30px;

  @media screen and (max-width: 1280px) {
    padding: 22px 60px;
    padding-bottom: 20px;
    max-height: 530px;
  }
  @media screen and (max-width: 767px) {
    padding: 15px 20px;
    width: auto;
    max-height: 533px;
  }
`;
const FieldWrap = styled.div`
  margin-top: 16px;
`;
const FiledTxt = styled.div`
  text-align: center;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 14.989px;
  color: #454545;
  text-align: left;
`;
const FiledInput = styled.input`
  outline: none;
  border-radius: 7px;
  border: 1px solid #ff7624;
  background-color: #fff;
  padding: 9px;
  width: 90%;
  margin-top: 10px;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;

  @media screen and (max-width: 767px) {
    width: 80%;
  }
`;
const ButtonWrapDwn = styled.div`
  margin-top: 30px;
  margin-bottom: 60px;
`;
const DwnldBtn = styled.div`
  background-color: #ff7624;
  border-radius: 10px;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  width: 275px;
  margin: 0 auto;
  cursor: pointer;

  &:hover {
    background-color: #cd5900;
  }

  @media screen and (max-width: 767px) {
    width: 240px;
  }
`;
const DwnldImg = styled.div``;

const DwnldBtnTxt = styled.p`
  margin: 0;
  color: #fff;
  font-family: Roboto;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;

  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;
const ErrorMessage = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 5px;
`;

export default function SubscribePopup(props) {
  const [isOpen, setIsOpen] = useState(true);
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [email, setEmail] = useState("");
  const [areaOfInterest, setAreaOfInterest] = useState("");
  const [show, setShow] = useState(false);
  const [type, setType] = useState("");
  const router = useRouter();

  useEffect(() => {
    function generateRandomEmail() {
      // Generate a random string for the email username
      const randomString = Math.random().toString(36).substring(7);

      // Use a fixed domain or replace it with your desired domain
      const domain = "example.com";

      // Combine the random string and domain to create the email address
      const email = `${randomString}@${domain}`;

      return email;
    }

    // Example usage
    const randomEmail = generateRandomEmail();
    setEmail(randomEmail);
  }, []);

  const handleClose = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      "Clicked on close button",
      "2025 Subscribe Form - Popup"
    );
    props.setShowSub(false);
  };
  const [error, setError] = useState("");
  const url =
    process.env.NEXT_PUBLIC_REACT_APP_RDT_SERVICE_URL +
    "/rdt/interactivestory/savereport";
  const handleupdateClick = async (checkDownloadIsRequired, subscribe) => {
    const updateObj = {
      name: name,
      company: company,
      jobtitle: jobTitle,
      email: email,
      interest: areaOfInterest,
      requesttype: subscribe,
      identifier: checkDownloadIsRequired,
      "year": router.asPath.includes("2025") ? "2025" : "2024"
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updateObj),
      });
      const msg = await response.json();
      if (!response.ok) {
        throw new Error("Error updating account data");
      }
    } catch (error) {
      console.error("Error updating account data:", error);
    }
    // props.setShowSub(false);
  };
  // Create state variables for error messages
  const [nameError, setNameError] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [jobTitleError, setJobTitleError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [areaOfInterestError, setAreaOfInterestError] = useState("");
  const [show1, setShow1] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  // Function to handle form submission

  const handleSubmit = () => {
    setType("Download");
    //user track
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on " Subscribe to 2025 Report" button`,
      "2025 Subscribe Form - Popup"
    );
    // Validate each field
    if (!name) {
      setNameError("Please enter your name");
    } else if (!/^[a-zA-Z]+([a-zA-Z0-9\s]*)*$/.test(name)) {
      setNameError("Please enter valid name");
    } else {
      setNameError("");
    }

    if (!company) {
      setCompanyError("Please enter your company name");
    } else if (!/^[a-zA-Z]+([a-zA-Z0-9\s]*)*$/.test(company)) {
      setCompanyError("Please enter valid company name");
    } else {
      setCompanyError("");
    }

    if (jobTitle && !/^[a-zA-Z]+([a-zA-Z0-9\s]*)*$/.test(jobTitle)) {
      setJobTitleError("Please enter valid job title");
    } else {
      setJobTitleError("");
    }
    if (email.length == 0) {
      setEmailError("Email is required");
    } else if (!email) {
      setEmailError("Please enter your work email address");
    } else if (!isValidEmail(email)) {
      setEmailError("Please enter your valid Email Id");
    } else {
      // Check if the email is already in local storage
    }

    if (!areaOfInterest) {
      setAreaOfInterestError("Please enter your area of interest");
    } else {
      setAreaOfInterestError("");
    }
    setSubmitClicked(true);
  };
  // Function to validate email format
  const isValidEmail = (value) => {
    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };
  useEffect(() => {
    if (submitClicked) {
      // If all fields are valid, you can proceed with the form submission logic
      if (
        name &&
        company &&
        !jobTitleError &&
        email &&
        isValidEmail(email) &&
        !checkPublicDomain(email) &&
        areaOfInterest &&
        !areaOfInterestError &&
        !companyError &&
        !nameError
      ) {
        // Save the email to local storage
        localStorage.setItem("storedEmail", email);
        // Your form submission logic goes here
        handleupdateClick("yes", "Download");
        //show the thankyou popup
        setShow(true);
        props.setfinalPopUp && props.setfinalPopUp(true);
      }
      if (isValidEmail(email)) {
        if (checkPublicDomain(email)) {
          setEmailError("Enter Work Email");
        }
      }
    }
    setSubmitClicked(false);
  }, [submitClicked]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }

    return () => {
      // Cleanup function to revert the style when the component unmounts
      document.body.style.overflow = "visible";
    };
  }, [isOpen]);

  useEffect(() => {
    var values = JSON.parse(localStorage.getItem("subscribeformdetails"));

    if (
      values &&
      typeof values === "object" &&
      Object.keys(values).length > 0
    ) {
      setName(values.name);
      setCompany(values.company);
      setJobTitle(values.jobtitle);
      setEmail(values.email);

      setAreaOfInterest(values.interest);
    }
  }, []);
  const { pathname, query, asPath } = router;
  const search = asPath.split("?")[1] || "";
  const isCesPresent = pathname.includes("ces") || search.includes("ces");
  const isCesPresent2024 =
    pathname.includes("ces-2024") && search.includes("ces-2024");

  return (
    <div>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={() => handleClose()}
        ariaHideApp={false}
        className="modal-popup-SubPopUp"
      >
        <PopupWrap>
          <div>
            <BannerLeft>
              <ContentRWrap>
                <P
                  text={`Ideapoke CES ${isCesPresent2024 ? 2025 : isCesPresent ? 2024 : 2024
                    } Report`}
                  color="#fff"
                  fontSize="32px"
                  fontWeight="700"
                  letterSpacing="0.4px"
                ></P>
                <P
                  text="Trends & Innovations Report "
                  color="#fff"
                  fontSize="24px"
                  fontWeight="700"
                  letterSpacing="0.4px"
                ></P>
                <div>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>
                      Innovations that created buzz in{" "}
                      {`${isCesPresent2024 ? 2025 : isCesPresent ? 2024 : 2024
                        }`}{" "}
                    </ListContent>
                  </ListWrap>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>Companies that headlined the show</ListContent>
                  </ListWrap>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>
                      Impact of these Tech Trends in your area of interest
                    </ListContent>
                  </ListWrap>
                </div>
              </ContentRWrap>
            </BannerLeft>
          </div>

          <div style={{ position: "relative" }}>
            <div className="closePopup mg-0" onClick={() => handleClose()}>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.01689 1.01689C1.34785 0.685932 1.79673 0.5 2.26478 0.5C2.73283 0.5 3.18171 0.685932 3.51267 1.01689L11 8.50422L18.4873 1.01689C18.8183 0.685932 19.2672 0.5 19.7352 0.5C20.2033 0.5 20.6521 0.685932 20.9831 1.01689C21.3141 1.34785 21.5 1.79673 21.5 2.26478C21.5 2.73283 21.3141 3.18171 20.9831 3.51267L13.4958 11L20.9831 18.4873C21.3141 18.8183 21.5 19.2672 21.5 19.7352C21.5 20.2033 21.3141 20.6521 20.9831 20.9831C20.6521 21.3141 20.2033 21.5 19.7352 21.5C19.2672 21.5 18.8183 21.3141 18.4873 20.9831L11 13.4958L3.51267 20.9831C3.18171 21.3141 2.73283 21.5 2.26478 21.5C1.79673 21.5 1.34785 21.3141 1.01689 20.9831C0.685931 20.6521 0.5 20.2033 0.5 19.7352C0.5 19.2672 0.685931 18.8183 1.01689 18.4873L8.50422 11L1.01689 3.51267C0.685931 3.18171 0.5 2.73283 0.5 2.26478C0.5 1.79673 0.685931 1.34785 1.01689 1.01689Z"
                  fill="#676767"
                />
              </svg>
            </div>
            <BannerRight>
              <P
                text={`Download ${isCesPresent2024 ? 2025 : isCesPresent ? 2024 : 2024
                  } Report`}
                color="#454545"
                fontSize="24px"
                fontWeight="600"
                mobFontSize="23px"
              ></P>
              <FieldWrap>
                <FiledTxt>
                  Name<span style={{ color: "red" }}>*</span>
                </FiledTxt>
                <FiledInput
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {nameError && <ErrorMessage>{nameError}</ErrorMessage>}
              </FieldWrap>

              <FieldWrap>
                <FiledTxt>
                  Company<span style={{ color: "red" }}>*</span>
                </FiledTxt>
                <FiledInput
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                />
                {companyError && <ErrorMessage>{companyError}</ErrorMessage>}
              </FieldWrap>

              <FieldWrap>
                <FiledTxt>Job Title</FiledTxt>
                <FiledInput
                  value={jobTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                />
                {jobTitleError && <ErrorMessage>{jobTitleError}</ErrorMessage>}
              </FieldWrap>

              <FieldWrap>
                <FiledTxt>
                  Email ID<span style={{ color: "red" }}>*</span>
                </FiledTxt>
                <FiledInput
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {emailError && <ErrorMessage>{emailError}</ErrorMessage>}
                {error && <ErrorMessage>{error}</ErrorMessage>}
              </FieldWrap>

              <FieldWrap>
                <FiledTxt>
                  What is your area of interest?
                  <span style={{ color: "red" }}>*</span>
                </FiledTxt>
                <FiledInput
                  value={areaOfInterest}
                  onChange={(e) => setAreaOfInterest(e.target.value)}
                />
                {areaOfInterestError && (
                  <ErrorMessage>{areaOfInterestError}</ErrorMessage>
                )}
              </FieldWrap>

              <ButtonWrapDwn
                onClick={() => {
                  handleSubmit();
                }}
              >
                <DwnldBtn>
                  <DwnldImg>
                    <Image src={Download} alt="Download" />
                  </DwnldImg>
                  <DwnldBtnTxt>{`Download ${isCesPresent2024 ? 2025 : isCesPresent ? 2024 : 2024
                    } Report`}</DwnldBtnTxt>
                </DwnldBtn>
              </ButtonWrapDwn>
            </BannerRight>
          </div>
        </PopupWrap>
      </ReactModal>
    </div>
  );
}
